module.exports = __webpack_public_path__ + "static/img/cryptoqubes.097cca2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/full/projects/cryptoqubes.png
// module id = m12J
// module chunks = 0